import isEmpty from 'lodash/isEmpty';

import { IAccount } from '@share/common-types';
import { LIFE_STYLE_NAME_PARAM, SESSION_KEY_TOKEN_NAME_PARAM } from '@share/constants';

import { IsImpersonatingStore } from './impersonator';
import { LoginType } from './login';
import { UrlUtils } from './urls';

/** Same wallet / SSO fields manual card checkout adds to book-*-with-card bodies. */
export interface IExpressWalletSsoContext {
  account: IAccount | null | undefined;
  userWallet: unknown;
  selectedClientCash: number | null | undefined;
}

/**
 * Mutates `data` with `clientCashAmount`, `ssoSessionKey`, and `lifeType` when the same
 * rules as manual checkout apply (Capital/puntos + private SSO + cars impersonation).
 */
export function applyExpressWalletSsoToPayload(
  data: Record<string, unknown>,
  ctx: IExpressWalletSsoContext,
  options?: { carsImpersonationLifeType?: boolean },
): void {
  const { account, userWallet, selectedClientCash } = ctx;
  const isPrivateWithToken = account?.type === LoginType.PrivateWithToken;
  const privateTokenFromUrl = account?.privateTokenFromUrl;

  if (isPrivateWithToken && privateTokenFromUrl) {
    data.ssoSessionKey = UrlUtils.getSearchParam(SESSION_KEY_TOKEN_NAME_PARAM);
    data.lifeType = UrlUtils.getSearchParam(LIFE_STYLE_NAME_PARAM);
  } else if (options?.carsImpersonationLifeType) {
    const impersonatingStore = IsImpersonatingStore();
    if (!isEmpty(impersonatingStore)) {
      data.lifeType = impersonatingStore;
    }
  }

  const hasClientCash = account?.hasClientCash;
  const isLogged = !!userWallet;
  if (hasClientCash && isLogged) {
    data.clientCashAmount = selectedClientCash ? selectedClientCash : 0;
  }
}
